
import { Component } from 'vue-property-decorator';
import Vue from 'vue'
import SinistersList from './components/SinistersList.vue'
import { AuthService } from '../../core/auth/services/auth.service'

@Component({
    components: {
        SinistersList
    }
})
export default class PageItemWithSinisters extends Vue {
    async created(){
        // `/me/` en paralelo: trae `customers` / `is_smartway` / `is_auditor` aunque la sesión sea de antes de que existieran
        this.refreshUserInfo();
        // Load properties first (for translations)
        await this.loadProperties();
    }

    /** Actualiza el `userInfo` de la sesión con `/me/`. Si falla, queda el guardado (columna y filtros según ese). */
    async refreshUserInfo(){
        try {
            const userInfo = await AuthService.getUserInfo();
            await this.$store.dispatch('auth/setUserInfo', userInfo);
        } catch (error) {
            console.warn('No se pudo refrescar /me/:', error);
        }
    }

    async loadProperties(){
        try {
            await this.$store.dispatch('properties/loadProperties');
        } catch (error) {
            console.error('Error loading properties:', error);
        }
    }
}
